export const itemBankAdminI18n = {
  itemBankAdmin: {
    program: 'Program',
    confidentialNotice: 'Exam items are confidential assessment material. '
      + 'Every item view, change and export here is written to the audit log.',
    noPrograms: 'No item bank programs exist yet.',
    tabs: {
      coverage: 'Coverage',
      items: 'Items',
      smes: 'SMEs',
      assignments: 'Assignments',
      blueprint: 'Blueprint',
      importExport: 'Import & export',
      exams: 'Exams',
      auditLog: 'Audit log',
    },
    errors: {
      generic: 'Something went wrong. Please try again.',
    },
  },
};

export const itemBankAdminI18nEs = {
  itemBankAdmin: {
    program: 'Programa',
    confidentialNotice: 'Los ítems de examen son material de evaluación confidencial. '
      + 'Cada visualización, cambio y exportación de un ítem aquí se registra en el registro de auditoría.',
    noPrograms: 'Todavía no existen programas en el banco de ítems.',
    tabs: {
      coverage: 'Cobertura',
      items: 'Ítems',
      smes: 'Expertos en la materia',
      assignments: 'Asignaciones',
      blueprint: 'Tabla de especificaciones',
      importExport: 'Importar y exportar',
      exams: 'Exámenes',
      auditLog: 'Registro de auditoría',
    },
    errors: {
      generic: 'Ocurrió un error. Inténtalo de nuevo.',
    },
  },
};
